import LocationMarkerIcon from '@heroicons/react/outline/esm/LocationMarkerIcon.js'

import { Link } from '@tribeplatform/react-ui-kit/Link'

import { CustomFieldViewProps } from '../utils.js'

export const LocationView = ({ value }: CustomFieldViewProps) => {
  if (!value) {
    return null
  }
  return (
    <Link
      className="text-content-subdued flex space-s-1 items-center"
      onClick={e => e.stopPropagation()}
    >
      <LocationMarkerIcon className="w-5 h-5" />
      <span>{value}</span>
    </Link>
  )
}
